export default "__VITE_ASSET__1839a86a__"